export const LOGO_URL = "https://media.lostdrkc.in/wp-content/uploads/2026/09/LOSTDC-NETWORK-e1790010678758.png";

export default function Logo({ className = "h-14 sm:h-16", withText = false }) {
  return (
    <div className={`inline-flex items-center gap-2 ${withText ? "" : ""}`}>
      <img
        src={LOGO_URL}
        alt="LostDC Network"
        className={`${className} w-auto object-contain drop-shadow-[0_0_22px_rgba(255,191,0,0.45)]`}
        loading="eager"
        data-testid="site-logo"
      />
    </div>
  );
}
